import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { Form } from 'react-bootstrap';

export const PrePaymentReceiptComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeCustomerData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeCustomerData }) => {
  const { values, setFieldValue } = formik;
  const navigate = useNavigate();

  const handleSubmit = () => {
    // للسلفة، ننشئ قائمة فارغة لأن المبلغ مدخل يدوياً
    formik?.setFieldValue('scheduleList', []);
    onClose();
  };

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;

    // السماح بالأرقام والنقطة فقط
    const sanitizedValue = input.replace(/[^0-9.]/g, '');

    // منع أكثر من نقطة واحدة
    const parts = sanitizedValue.split('.');
    let finalValue = sanitizedValue;

    if (parts.length > 2) {
      finalValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // تحديث القيمة في formik
    setFieldValue('amount', finalValue);
  };

  // const isFormValid = values.amount && values.amount > 0;
  // التحقق من جميع الحقول المطلوبة
  const isFormValid =
    values.peopleId && values.organizationId && values.amount && parseFloat(values.amount) > 0;

  return (
    <div>
      <div className='row g-3 mb-4'>
        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>العميل</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر العميل'
              allowClear
              treeDefaultExpandAll={false}
              value={values.peopleId}
              onChange={option => {
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeCustomerData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المبلغ</label>
            <Form.Control
              className='form-control text-center fw-bold border-theme'
              type='text'
              autoComplete='off'
              name='amount'
              value={values.amount || ''}
              onChange={handleAmountChange}
              placeholder='0.00'
            />
          </div>
        </div>
      </div>

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            {/* {isFormValid && (
              <div className='alert alert-success d-flex align-items-center py-2 mb-0' role='alert'>
                <i className='fas fa-check-circle me-2'></i>
                <div>جاهز لإضافة سلفة بمبلغ {values.amount?.toLocaleString()}</div>
              </div>
            )} */}
          </div>

          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-check me-2'></i>
              إستمرار
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AR/ArReceipts', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
